/* OddDrop browser-local analytics exclusion. No IP, account or identity matching. */
(function () {
  'use strict';
  if (window.OddBrowserExclusion) return;
  var KEY = 'odddrop_analytics_excluded_v1';
  var script = document.currentScript;
  var mid = script && script.getAttribute('data-od-measurement-id');
  var marked = false, status, detail, exclude, restore;
  try { marked = localStorage.getItem(KEY) === '1'; } catch (_) {}
  function applyFlag() { if (mid) window['ga-disable-' + mid] = marked; }
  applyFlag();
  window.OddBrowserExclusion = { active:function () { return marked; } };

  function privacy() { return window.Shopify && window.Shopify.customerPrivacy; }
  function read() {
    var p = privacy(), consent = '', allowed = null;
    try {
      consent = p && p.currentVisitorConsent().analytics;
      allowed = p && p.analyticsProcessingAllowed();
    } catch (_) {}
    return { marker:marked, analytics:consent || 'unset', allowed:allowed,
      ga_disabled:!!(mid && window['ga-disable-' + mid] === true),
      theme_blocked:!!(window.OddConsent && !window.OddConsent.allowed()) };
  }
  function render(message) {
    if (!status) return;
    var state = read();
    var verified = state.marker && state.analytics === 'no' && state.allowed === false && state.ga_disabled && state.theme_blocked;
    status.textContent = message || (verified ? 'This browser is excluded from analytics.' : 'Browser exclusion is not fully enabled.');
    status.setAttribute('data-verified', String(verified));
    detail.textContent = 'Local marker: ' + (state.marker ? 'ON' : 'OFF') + '\n' +
      'Shopify analytics choice: ' + state.analytics + '\n' +
      'Shopify analytics processing allowed: ' + String(state.allowed) + '\n' +
      'GA4 page tag disabled: ' + String(state.ga_disabled) + '\n' +
      'Theme analytics blocked: ' + String(state.theme_blocked);
    detail.setAttribute('data-state', JSON.stringify(state));
  }
  function ready(callback) {
    var p = privacy();
    if (p && typeof p.setTrackingConsent === 'function') { callback(p); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], function (error) {
        if (!error && privacy() && typeof privacy().setTrackingConsent === 'function') callback(privacy());
        else { render('Privacy API could not load. Exclusion has not been verified.'); buttons(false); }
      });
    } else { render('Privacy API unavailable. Exclusion has not been verified.'); buttons(false); }
  }
  function buttons(busy) { if (exclude) exclude.disabled = busy; if (restore) restore.disabled = busy; }
  function store(on) {
    try {
      if (on) localStorage.setItem(KEY, '1'); else localStorage.removeItem(KEY);
      if ((localStorage.getItem(KEY) === '1') !== on) throw new Error('storage');
      marked = on; applyFlag(); return true;
    } catch (_) { render('Browser storage is blocked. The local marker could not be saved.'); return false; }
  }
  // Consent is changed ONLY by the explicit button interaction, never on page load.
  function choose(on) {
    buttons(true);
    if (on && !store(true)) { buttons(false); return; }
    ready(function (p) {
      p.setTrackingConsent({analytics:!on}, function (result) {
        if (result && result.error) { render('Analytics preference was not saved. Please retry.'); buttons(false); return; }
        var ok = false;
        try { ok = p.currentVisitorConsent().analytics === (on ? 'no' : 'yes') && p.analyticsProcessingAllowed() === !on; } catch (_) {}
        if (!ok) { render('Saved response could not be verified. Please retry; no complete exclusion is claimed.'); buttons(false); return; }
        if (!on && !store(false)) { buttons(false); return; }
        if (window.OddConsent) window.OddConsent.refresh();
        render(on ? undefined : 'Exclusion removed; analytics is allowed in this browser. Reload to apply.');
        buttons(false);
      });
    });
  }
  function panel() {
    if (location.hash !== '#od-analytics-exclude' || document.getElementById('od-browser-exclusion')) return;
    var box = document.createElement('section'); box.id = 'od-browser-exclusion';
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', 'Browser analytics exclusion');
    box.style.cssText = 'position:fixed;z-index:2147483646;left:50%;top:50%;transform:translate(-50%,-50%);width:min(520px,calc(100vw - 32px));box-sizing:border-box;max-height:90vh;overflow:auto;background:#fffdf7;color:#15120c;border:2px solid #15120c;border-radius:14px;padding:24px;box-shadow:0 8px 45px #0006;font:16px/1.5 system-ui;text-align:left';
    var title = document.createElement('h2'); title.textContent = 'Browser analytics exclusion'; title.style.cssText = 'font:700 23px/1.3 system-ui;margin:0 0 12px';
    var note = document.createElement('p'); note.textContent = 'Only this browser profile is affected. No IP filter is used. Clearing site data or switching browsers requires enabling exclusion again. Orders and payments are not removed.';
    status = document.createElement('p'); status.id = 'od-browser-exclusion-status'; status.setAttribute('role', 'status'); status.style.fontWeight = '700';
    detail = document.createElement('pre'); detail.id = 'od-browser-exclusion-state'; detail.style.cssText = 'white-space:pre-wrap;font:13px/1.6 monospace;background:#f1f0eb;padding:12px;border-radius:6px';
    function button(text, action) {
      var el = document.createElement('button'); el.type = 'button'; el.textContent = text;
      el.style.cssText = 'display:block;width:100%;min-height:44px;border:1px solid #15120c;border-radius:7px;padding:10px;margin-top:10px;background:#fff;color:#15120c;font:600 16px/1.4 system-ui;cursor:pointer';
      el.addEventListener('click',action); return el;
    }
    exclude = button('Exclude this browser',function () { choose(true); });
    restore = button('Remove exclusion and allow analytics',function () { choose(false); });
    var reload = button('Reload and verify',function () { location.reload(); });
    var close = button('Close',function () { box.remove(); history.replaceState(null,'',location.pathname + location.search); });
    [title,note,status,detail,exclude,restore,reload,close].forEach(function (el) { box.appendChild(el); });
    document.body.appendChild(box); render();
    ready(function () { render(); });
  }
  document.addEventListener('DOMContentLoaded',panel);
  document.addEventListener('od:consent',function () { render(); });
  window.addEventListener('hashchange',panel);
  window.addEventListener('storage',function (event) {
    if (event.key !== KEY) return;
    marked = event.newValue === '1'; applyFlag();
    if (window.OddConsent) window.OddConsent.refresh();
    render();
  });
})();
